import React from 'react';
import { IconProps } from '../IconProps';
const SvgReview = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#Review_svg__clip0_3478_9502)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.714C0 .767.767 0 1.714 0h9.143c.947 0 1.714.767 1.714 1.714v3.503a5.714 5.714 0 00-6.773 8.498H1.714A1.714 1.714 0 010 12V1.714zm2.857 1.572a.714.714 0 100 1.428h2.857a.714.714 0 000-1.428H2.857zm0 2.857a.714.714 0 100 1.428H4.57a.714.714 0 100-1.428H2.857zM10.57 8a2.571 2.571 0 100 5.143 2.571 2.571 0 000-5.143zm-4.286 2.572a4.286 4.286 0 117.862 2.363l1.602 1.602a.857.857 0 01-1.212 1.212l-1.602-1.602a4.286 4.286 0 01-6.65-3.576z"
        fill={primaryColor}
      />
    </g>
    <defs>
      <clipPath id="Review_svg__clip0_3478_9502">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReview;
